<template>
  <b-container class="my-4">
    <b-card class="shadow-sm p-3 rating-card">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-start">
        <div class="d-flex align-items-center">
          <h4 class="mb-0 font-weight-bold">Driver Rating</h4>
        </div>

        <div class="text-right">
          <div class="text-muted">Feb 17, 2024</div>
          <small class="text-muted">05:30 PM</small>
          <div class="mt-2">
            <b-badge variant="success" pill class="px-3 py-2">
              <b-icon icon="check-circle" class="mr-1"></b-icon>
              Rated
            </b-badge>
          </div>
        </div>
      </div>

      <hr />

      <!-- Driver Info -->
      <div class="d-flex align-items-center mb-3">
        <b-avatar variant="primary" size="60px" class="mr-3"> SA </b-avatar>

        <div>
          <h5 class="mb-1 text-capitalize">stefen asanty</h5>
          <small class="text-muted"> Rated by: عزيز معتق عبيد المطيري </small>

          <!-- Stars -->
          <div class="d-flex align-items-center mt-2">
            <b-icon
              v-for="i in 5"
              :key="i"
              icon="star-fill"
              variant="warning"
              class="mr-1"
            ></b-icon>
            <img :src="require('@/assets/images/icons/star.svg')" alt="star" />
            <strong class="ml-2">5.0</strong>
          </div>
        </div>
      </div>

      <!-- Reason & Comment -->
      <b-card class="bg-light border-0 p-3">
        <div>
          <small class="text-uppercase text-muted font-weight-bold"> Reason </small>
          <p class="mb-3">Very professional and respectful</p>
        </div>

        <div>
          <small class="text-uppercase text-muted font-weight-bold"> Comment </small>
          <p class="mb-0">
            Excellent service, very punctual and friendly. The water delivery was smooth.
          </p>
        </div>
      </b-card>

      <!-- Footer -->
      <div class="d-flex justify-content-between align-items-center mt-4 p-3 bg-light rounded">
        <div>
          Main Driver:
          <strong class="text-capitalize">stefen asanty</strong>
        </div>

        <b-button variant="secondary"> Reassign </b-button>
      </div>
    </b-card>
  </b-container>
</template>

<script>
export default {
  name: 'DriverRatingCard',
}
</script>

<style scoped>
.rating-card {
  border-radius: 12px;
}
</style>
